const toyota = {
  state: () => ({
    images: {
      sedans: [
        {
          modelName: "Avalon",
          sideView: require("../../../static/images/carcuts/toyota/side-view/avalon-21.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/avalon.png"),
          trims: ["XLE", "XLE Hybrid", "XSE Nightshade", "XSE Hybrid", "TRD", "Touring", "Limited", "Limited Hybrid"]
        },
        {
          modelName: "Camry",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-Camry-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/camry.png"),
          trims: ["LE", "SE", "SE Nightshade", "XLE", "XSE", "TRD", "XLE V6", "XSE V6"]
        },
        {
          modelName: "Corolla",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-Corolla-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/corolla-20.png"),
          trims: ["L", "SE", "XSE", "LE Hybrid"]
        },
        {
          modelName: "Prius",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-Prius-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/prius.png"),
          trims: ["L", "Eco", "LE", "XLE", "Limited", "LE AWD-e", "XLE AWD-e"]
        },
        {
          modelName: "Yaris",
          sideView: require("../../../static/images/carcuts/toyota/side-view/yaris-20.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/yaris.png"),
          trims: ["L", "LE", "XLE"]
        },
        {
          modelName: "86",
          sideView: require("../../../static/images/carcuts/toyota/side-view/86-20.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/86.png"),
          trims: ["Base", "GT", "TRD Special Edition"]
        },
      ],
      suvs: [
        {
          modelName: "4Runner",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-4Runner-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/4runner.png"),
          trims: ["SR5", "Trail Special Edition", "SR5 Premium", "TRD Off-Road", "TRD Off-Road Premium", "Venture Special Edition", "Limited", "Nightshade Special Edition"]
        },
        {
          modelName: "C-HR",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-C-HR-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/c-hr.png"),
          trims: ["L", "XLE", "Limited"]
        },
        {
          modelName: "Highlander",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-Highlander-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/highlander.png"),
          trims: ["LE", "LE Plus", "XLE", "SE", "Limited"]
        },
        {
          modelName: "Landcruiser",
          sideView: require("../../../static/images/carcuts/toyota/side-view/land-cruiser-20.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/landcruiser.png"),
          trims: ["Base", "Heritage Edition"]
        },
        {
          modelName: "RAV4",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-RAV4-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/rav4-19.png"),
          trims: ["LE", "XLE", "XLE Premium", "Adventure", "TRD Off-Road", "Limited"]
        },
        {
          modelName: "Sequoia",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-Sequoia-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/sequoia.png"),
          trims: ["SR5", "TRD Sport", "Limited", "Platinum"]
        },
        {
          modelName: "Sienna",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-Sienna-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/sienna.png"),
          trims: ["LE", "XLE", "Woodland Edition", "XSE", "Limited", "Platinum"]
        },
      ],
      trucks: [
        {
          modelName: "Tacoma",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-Tacoma-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/tacoma.png"),
          trims: ["SR", "SR5", "TRD Sport", "TRD Off-Road", "Limited", "TRD Pro"]
        },
        {
          modelName: "Tundra",
          sideView: require("../../../static/images/carcuts/toyota/side-view/Toyota-2019-Tundra-2.png"),
          angleView: require("../../../static/images/carcuts/toyota/angle-view/tundra.png"),
          trims: ["SR", "SR5", "Limited", "Platinum", "1794 Edition", "TRD Pro"]
        },
      ],
      lifestyleImages: {
        defaultImage: require("../../../static/images/carcuts/toyota/lifestyle/prius-prime-20.jpg"),
        sedanImage: require("../../../static/images/carcuts/toyota/lifestyle/avalon-20.jpg"),
        suvImage: require("../../../static/images/carcuts/toyota/lifestyle/rav4-19.jpg"),
        truckImage: require("../../../static/images/carcuts/toyota/lifestyle/tundra-24.jpeg")
      },
      videoLink: [
        "https://player.vimeo.com/external/233375995.hd.mp4?s=e9ab01181ece5b6425f3c4db9f9d07338c20562a&profile_id=175"
      ],
      roundButtons: [
        require("../../../static/images/buttons/round-buttons/toyota-New.png"), require("../../../static/images/buttons/round-buttons/toyota-Used.png"), require("../../../static/images/buttons/round-buttons/toyota-ScheduleService.png"), require("../../../static/images/buttons/round-buttons/toyota-Worth.png")
      ],
      browseButtons: [
        require("../../../static/images/buttons/browse-buttons/toyota-new.png"), require("../../../static/images/buttons/browse-buttons/toyota-used.png"), require("../../../static/images/buttons/browse-buttons/toyota-service.png"), require("../../../static/images/buttons/browse-buttons/toyota-specials.png")
      ],
      swoopIcons: [
        require("../../../static/images/buttons/swoop-icons/toyota01.png"), require("../../../static/images/buttons/swoop-icons/toyota03.png"), require("../../../static/images/buttons/swoop-icons/toyota02.png")
      ],
      homeBanners: [
        require("../../../static/images/banners/toyota/CM-MS-24-Toyota-Established.jpg"), require("../../../static/images/banners/toyota/CM-MS-24-Toyota-Lifestyle.jpg"), require("../../../static/images/banners/toyota/CM-MS-24-Toyota-Modern.jpg"), require("../../../static/images/banners/toyota/CM-MS-24-Toyota-Playful.jpg")
      ],
      stripBanners: [
        require("../../../static/images/banners/toyota/Sokal-Toyota-SRS-112221-Established.jpeg"), require("../../../static/images/banners/toyota/Sokal-Toyota-SRS-112221-Lifestyle.jpeg"), require("../../../static/images/banners/toyota/Sokal-Toyota-SRS-112221-Modern.jpeg"), require("../../../static/images/banners/toyota/Sokal-Toyota-SRS-112221-Playful.jpeg")
      ],
      logoExample: [
        require("../../../static/images/buttons/logos/dd-logo-toyota.png"),
        require("../../../static/images/buttons/logos/dd-logo-toyota-w.png")
      ]
    },
   colors: {
      "--primary-color": "#EB0A1E",
      "--primary-dark": "#000",
      "--primary-light": "#FFF",
      "--secondary-color": "#EB0A1E",
      "--secondary-dark": "#000",
      "--secondary-light": "#F5f5f5"
    },
    fonts: {
      "--heading-text": "ToyotaType-Semibold, 'Helvetica Neue', Arial, sans-serif",
      "--subheading-text": "ToyotaType-Semibold, 'Helvetica Neue', Arial, sans-serif",
      "--body-text": "ToyotaType-Book, 'Helvetica Neue', Arial, sans-serif",
      "--bold-text": "ToyotaType-Semibold, 'Helvetica Neue', Arial, sans-serif"
    }
  })
}


export default toyota